import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { memo, useCallback, useMemo, useState } from "react";
import MainApi from "./../../../../../services/mainApi.service";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { IMarComAutomationClassifications } from "../../../../../models/mar-com-automation-classifications";
import { Classifications } from "./ClassificationsForm/Classifications";

const CLASSIFICATION_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationClassification/";
const classificationService = new MainApi<IMarComAutomationClassifications>(
  CLASSIFICATION_ROUTE
);

const translationPath = "page.4uMarCom.automationRules.marcom_classifications.";

export const ClassificationsPage = memo(() => {
  const [classificationForm, setClassificationForm] = useState(false);

  const { id } = useParams();

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const columns: GridColDef<IMarComAutomationClassifications>[] = [
    {
      field: "listClassification",
      headerName:
        t(translationPath + "list_classification") || "List Classification",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.row.listClassification.name}
            tooltip={params.row.listClassification.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
  ];

  const handleAdd = () => {
    setClassificationForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IMarComAutomationClassifications>
  ) => {
    if (!params.row) return;
    setClassificationForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setClassificationForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      MarComAutomationRuleId: id,
    };
  }, [id]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {classificationForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Classifications
            id={selectedId}
            marComAutomationRuleId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!classificationForm && (
        <Box height={600}>
          <Table<IMarComAutomationClassifications>
            showDefaultMacroFilters={false}
            service={classificationService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            serviceProps={props}
            searchInputPlaceHolder={
              t(translationPath + "search") || "Search for a classification"
            }
            addButtonLabel={
              t(translationPath + "add_classification") || "Add Classification"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
